//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapMutations } from 'vuex';


export default {
    name: 'AccountDetails',
    data() {
        return {
            accountType: undefined,
            amountOfInvestment: '',
            maximalAmountAvailable: '',
            maximalIndividualAmountAvailable: '',
            zinspilot: false,
        };
    },
    computed: {
        ...mapState(['currency', 'step', 'accountDetails']),
    },
    methods: {
        ...mapMutations([
            'setAccountDetails',
        ]),
        onSubmit() {
            this.$store.dispatch('setAccountDetails', {
                accountType: this.accountType,
                amountOfInvestment: this.amountOfInvestment,
                maximalAmountAvailable: this.maximalAmountAvailable,
                maximalIndividualAmountAvailable: this.maximalIndividualAmountAvailable,
                zinspilot: this.zinspilot,
            }).then(() => this.$store.dispatch('setStep', this.step + 1));
        },
        back() {
            this.$store.dispatch('setStep', this.step - 1);
        },
    },
    mounted() {
        if(Object.keys(this.accountDetails).length) {
            this.accountType = this.accountDetails.accountType;
            this.amountOfInvestment = this.accountDetails.amountOfInvestment;
            this.maximalAmountAvailable = this.accountDetails.maximalAmountAvailable;
            this.maximalIndividualAmountAvailable = this.accountDetails.maximalIndividualAmountAvailable;
        }
        if (this.$route.query.zp == 'true') {
            this.zinspilot = true;
        }
    },
};
